module.exports = __webpack_public_path__ + "img/diamond.35d0f377.svg";